import React from 'react';
import { Check } from 'lucide-react';

export interface CheckboxProps {
  id?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
}

export function Checkbox({ id, checked, onCheckedChange, className = '' }: CheckboxProps) {
  return (
    <button
      type="button"
      id={id}
      role="checkbox"
      aria-checked={checked}
      onClick={() => onCheckedChange(!checked)}
      className={`w-4 h-4 rounded border-2 flex items-center justify-center transition-colors ${
        checked
          ? 'bg-primary border-primary text-primary-foreground'
          : 'border-gray-300 hover:border-primary/50'
      } ${className}`}
    >
      {checked && <Check className="w-3 h-3" />}
    </button>
  );
}
